// extracted by css-extract-rspack-plugin
export default {"projectSelectorForm":"gfl488_t8Q7NziMK","projectSelectorButton":"hQNbbz4IQLuC9LfY"};